export const TypeSelected = (inputValue) => {
    return {
        type: 'TYPESELECTED',
        payload: inputValue
    }
}
export const LoanTypeSelected = (inputValue) => {
    return {
        type: 'LOANTYPESELECTED',
        payload: inputValue
    }
}
export const PurchasePriceUpdate = (inputValue) => {
    return {
        type: 'PURCHASEPRICEUPDATE',
        payload: inputValue
    }
}
export const DownPaymentInUSDsUpdate = (inputValue) => {
    return {
        type: 'DOWNPAYMENTINUSDSUPDATE',
        payload: inputValue
    }
}
export const DownPaymentInPercentsUpdate = (inputValue) => {
    return {
        type: 'DOWNPAYMENTINPERCENTSSUPDATE',
        payload: inputValue
    }
}
export const immigrationStatusUpdate = (inputValue) => {
    return {
        type: 'IMMIGRATIONSTATUSUPDATE',
        payload: inputValue
    }
}
export const ficoScoreUpdate = (inputValue) => {
    return {
        type: 'FICOSCOREUPDATE',
        payload: inputValue
    }
}
export const CreditScoreUpdate = (inputValue) => {
    return {
        type: 'CREDITSCOREUPDATE',
        payload: inputValue
    }
}
export const ShowButtons = (inputValue) => {
    return {
        type: 'SHOWBUTTONSUPDATE',
        payload: inputValue
    }
}

export const propertyTypeUpdate = (inputValue) => {
    return {
        type: 'PROPERTYTYPEUPDATE',
        payload: inputValue
    }
}
export const propertyUsedUpdate = (inputValue) => {
    return {
        type: 'PROPERTYUSEDUPDATE',
        payload: inputValue
    }
}

export const penaltyTermUpdate = (inputValue) => {
    return {
        type: 'PENALTYTERMUPDATE',
        payload: inputValue
    }
}

export const lowRatesUpdate = (inputValue) => {
    return {
        type: 'LOWRATESUPDATE',
        payload: inputValue
    }
}
export const lowRatesOptionUpdate = (inputValue) => {
    return {
        type: 'LOWRATESOPTION',
        payload: inputValue
    }
}
export const estimatedValueUpdate = (inputValue) => {
    return {
        type: 'ESTIMATEDVALUEUPDATED',
        payload: inputValue
    }
}
export const loanBalanceUpdate = (inputValue) => {
    return {
        type: 'LOANBALANCEUPDATED',
        payload: inputValue
    }
}
export const documentTypeUpdate = (inputValue) => {
    return {
        type: 'DOCUMENTTYPEUPDATE',
        payload: inputValue
    }
}
export const cashoutAmountUpdate = (inputValue) => {
    return {
        type: 'CASHOUTAMOUNTUPDATED',
        payload: inputValue
    }
}
export const estimatedHomeValueUpdate = (inputValue) => {
    return {
        type: 'ESTIMATEDHOMEVALUEUPDATED',
        payload: inputValue
    }
}
export const loanAmountTotalUpdate = (inputValue) => {
    return {
        type: 'LOANAMOUNTTOTALUPDATE',
        payload: inputValue
    }
}
export const zipCodeUpdate = (inputValue) => {
    return {
        type: 'ZIPCODEUPDATE',
        payload: inputValue
    }
}
export const countryStateUpdate = (inputValue) => {
    return {
        type: 'COUNTRYSTATEUPDATE',
        payload: inputValue
    }
}
export const stateCountyUpdate = (inputValue) => {
    return {
        type: 'STATECOUNTYUPDATE',
        payload: inputValue
    }
}
export const stateCountyNameUpdate = (inputValue) => {
    return {
        type: 'STATECOUNTYNAMEUPDATE',
        payload: inputValue
    }
}
export const veteranUpdate = (inputValue) => {
    return {
        type: 'VETERANUPDATE',
        payload: inputValue
    }
}
export const stateListUpdate = (inputValue) => {
    return {
        type: 'STATELISTUPDATE',
        payload: inputValue
    }
}
export const setPropertyPurpose = (inputValue) => {

    return {
        type: 'SELECTEDPROPERTYPURPOSE',
        payload: inputValue
    }
}

export const amortizationUpdate = (inputValue) => {
    return {
        type: 'AMORTIZATIONUPDATE',
        payload: inputValue
    }
}
export const amortizationTypeUpdate = (inputValue) => {
    return {
        type: 'AMORTIZATIONTYPEUPDATE',
        payload: inputValue
    }
}
export const previousAmortizationTypeUpdate = (inputValue) => {
    return {
        type: 'PREVIOUSAMORTIZATIONTYPEUPDATE',
        payload: inputValue
    }
}
export const armValueUpdate = (inputValue) => {
    return {
        type: 'ARMVALUEUPDATE',
        payload: inputValue
    }
}
export const priceScenarioResponseUpdate = (inputValue) => {
    return {
        type: 'PRICESCENARIOUPDATE',
        payload: inputValue
    }
}
export const textDescriptionUpdate = (inputValue) => {
    return {
        type: 'TEXTDESCRIPTIONUPDATE',
        payload: inputValue
    }
}
export const unhideCustomizeQuoteLabelUpdate = (inputValue) => {
    
    return {
        type: 'UNHIDECUSTIMEQUOTELABEL',
        payload: inputValue
    }
}

export const fhaTypeQuestionUpdate = (inputValue) => {
    return {
        type: 'FHATYPEQUESTIONUPDATE',
        payload: inputValue
    }
}

export const productTypeQuestionUpdate = (inputValue) => {
    return {
        type: 'PRODUCTTYPEQUESTIONUPDATE',
        payload: inputValue
    }
}
export const  priceDataLengthUpdate = (inputValue) => {
    return {
        type: 'RESPONSELENGTHUPDATE',
        payload: inputValue
    }
}

export const  ficoTypeUpdate = (inputValue) => {
    return {
        type: 'FICOTYPEUPDATE',
        payload: inputValue
    }
}

export const  miCoverageTypeUpdate = (inputValue) => {
    return {
        type: 'MICOVERAGETYPEUPDATE',
        payload: inputValue
    }
}

export const  subordinateFinanceUpdate = (inputValue) => {
    return {
        type: 'SUBORDINATEFINANCEUPDATE',
        payload: inputValue
    }
}

export const  checkLimitPrice = (inputValue) => {
    return {
        type: 'CHECKLIMITPRICE',
        payload: inputValue
    }
}

export const  setLoadingPriceScenario = (inputValue) => {
    return {
        type: 'SETLOADINGPRICESCENARIO',
        payload: inputValue
    }
}

export const  setErrorInBrokerForm = (inputValue) => {
    return {
        type: 'SETERRORINBROKERFORM',
        payload: inputValue
    }
}

export const  setStoreConfigData = (inputValue) => {
    return {
        type: 'SETSTORECONFIGDATA',
        payload: inputValue
    }
}

export const  setDeviceType = (inputValue) => {
    return {
        type: 'SETDEVICETYPE',
        payload: inputValue
    }
}

export const isDtiRatioHigherUpdate = (inputValue) => {
    return {
        type: 'ISDTIRATIOHIGHERUPDATE',
        payload: inputValue
    }
}

export const interestOnlyPaymentUpdate = (inputValue) => {
    return {
        type: 'INTERESTONLYPAYMENTUPDATE',
        payload: inputValue
    }
}

export const escrowUpdate = (inputValue) => {
    return {
        type: 'ESCROWUPDATE',
        payload: inputValue
    }
}

export const seeMyLoanFormDataUpdate = (inputValue) => {
    return {
        type: 'SETSEEMYLOANFORMDATA',
        payload: inputValue
    }
}

export const dpaUpdate = (inputValue) => {
    return {
        type: 'DPAUPDATE',
        payload: inputValue
    }
}

export const backRatioInPercentsUpdate = (inputValue) => {
    return {
        type: 'BACKRATIOINPERCENTSSUPDATE',
        payload: inputValue
    }
}
export const setCustomValue = (inputObj) => {
    return {
        type: 'SETCUSTOMVALUE',
        payload: inputObj
    }
}